"use client";

import { Moon, Sun } from "lucide-react";
import { useSyncExternalStore } from "react";

import { Button } from "@/components/ui/button";
import { useMetaColor } from "@/hooks/use-meta-color";
import { useSmoothTheme } from "@/hooks/use-smooth-theme";

const emptySubscribe = () => () => {};

export function ModeSwitcher() {
  const { toggleTheme: smoothToggleTheme, theme } = useSmoothTheme();
  const { setMetaColor, metaColor } = useMetaColor();

  const mounted = useSyncExternalStore(
    emptySubscribe,
    () => true,
    () => false,
  );

  const toggleTheme = (event: React.MouseEvent<HTMLButtonElement>) => {
    smoothToggleTheme({
      x: event.clientX,
      y: event.clientY,
    });
    setMetaColor(metaColor);
  };

  if (!mounted) {
    return (
      <Button
        size={"icon-sm"}
        variant="outline"
        className="group/toggle cursor-pointer"
        aria-label="Toggle theme"
        title="Toggle theme"
      >
        <span className="h-4 w-4" />
      </Button>
    );
  }

  return (
    <Button
      size={"icon-sm"}
      variant="outline"
      className="group/toggle cursor-pointer "
      onClick={toggleTheme}
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      title={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
    >
      {theme === "dark" ? <Sun /> : <Moon />}
    </Button>
  );
}
